@let tellentHrActive = !!isTellentHrActive();
@let growActive = !!isGrowActive();
@let whatsAppHiringActive = !!isWhatsAppHiringActive();
@let journeysActive = !!areJourneysActive();

<tlc-churn-flow-step-template [currentStep]="3" [reasonInfoboxMessage]="infoboxMessage()">
  <div class="left">
    <tlc-churn-flow-reason-template
      [heading]="'tlc.churn_flow.steps.moving_to_another_tool.heading' | translate"
      [subheading]="'tlc.churn_flow.steps.moving_to_another_tool.subheading' | translate"
      (stayWithTellent)="stayWithTellent()"
      (stillWantToCancel)="stillWantToCancel()"
    >
      <div class="solutions-container">
        <tlc-churn-flow-solution-card
          [iconVariant]="hris.iconVariant"
          [title]="hris.title"
          [subtitle]="hris.subtitle"
          [incentives]="hris.incentives"
        >
          <div class="additional-content-bottom">
            <a href="https://tellent.com/hr" target="_blank">
              <rt-icon name="open-in-new" colorToken="colorIconLinkDefault" />
              <span>{{
                'tlc.churn_flow.steps.moving_to_another_tool.solutions.hris.see_all_features'
                  | translate
              }}</span>
            </a>
          </div>
          <div class="actions">
            <rt-button variant="primary" (click)="activateHrTrial()" [disabled]="tellentHrActive">
              @if (tellentHrActive) {
                <rt-icon prefix name="check" colorToken="colorIconSuccessDefault" />
              } @else {
                <rt-icon prefix name="open-in-new" />
              }
              <span>{{ hris.ctaText }}</span>
            </rt-button>
          </div>
        </tlc-churn-flow-solution-card>

        <tlc-churn-flow-solution-card
          [iconVariant]="performanceManagement.iconVariant"
          [title]="performanceManagement.title"
          [subtitle]="performanceManagement.subtitle"
          [incentives]="performanceManagement.incentives"
        >
          <div class="actions">
            <rt-button
              variant="tertiary"
              (click)="askQuestionAboutAddon('performance_management')"
              [disabled]="growActive"
            >
              @if (growActive) {
                <rt-icon prefix name="check" colorToken="colorIconSuccessDefault" />
              } @else {
                <rt-icon prefix name="open-in-new" />
              }
              <span>{{ performanceManagement.ctaText }}</span>
            </rt-button>
          </div>
        </tlc-churn-flow-solution-card>

        <tlc-churn-flow-solution-card
          [iconVariant]="whatsappHiring.iconVariant"
          [title]="whatsappHiring.title"
          [subtitle]="whatsappHiring.subtitle"
          [incentives]="whatsappHiring.incentives"
        >
          <div class="actions">
            <rt-button
              variant="tertiary"
              (click)="askQuestionAboutAddon('whatsapp_hiring')"
              [disabled]="whatsAppHiringActive"
            >
              @if (whatsAppHiringActive) {
                <rt-icon prefix name="check" colorToken="colorIconSuccessDefault" />
              } @else {
                <rt-icon prefix name="open-in-new" />
              }
              <span>{{ whatsappHiring.ctaText }}</span>
            </rt-button>
          </div>
        </tlc-churn-flow-solution-card>

        <tlc-churn-flow-solution-card
          [iconVariant]="journeys.iconVariant"
          [title]="journeys.title"
          [subtitle]="journeys.subtitle"
          [incentives]="journeys.incentives"
        >
          <div class="actions">
            <rt-button
              variant="tertiary"
              (click)="askQuestionAboutAddon('journeys')"
              [disabled]="journeysActive"
            >
              @if (journeysActive) {
                <rt-icon prefix name="check" colorToken="colorIconSuccessDefault" />
              } @else {
                <rt-icon prefix name="open-in-new" />
              }
              <span>{{ journeys.ctaText }}</span>
            </rt-button>
          </div>
        </tlc-churn-flow-solution-card>
      </div>
    </tlc-churn-flow-reason-template>
  </div>

  <div class="right">
    <tlc-churn-flow-insights />
  </div>
</tlc-churn-flow-step-template>
